export const parseNairaInput = (value) => {
  if (value === null || value === undefined) return 0;
  const cleaned = String(value).replace(/[^0-9.-]+/g, "");
  const parsed = Number(cleaned);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const formatNairaInput = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const raw = String(value).replace(/[^\d.]/g, "");
  if (!raw) return "";

  const [integerPart, decimalPart] = raw.split(".");
  const integerValue = Number(integerPart || 0);
  const formattedInteger = integerValue.toLocaleString("en-NG");

  if (raw.includes(".")) {
    return `₦${formattedInteger}.${(decimalPart || "").slice(0, 2)}`;
  }

  return `₦${formattedInteger}`;
};
